/**
 * @voltxampere/ui — Drawing constants pulled from ZENIT_BRAND.md §7 / §9
 *
 * The brand bible declares stroke width 1.3-1.6 (zorunlu range) and
 * stroke color ivory (`#EFE6D2`) for all 20 symbols, with LED as the
 * one semantic exception (brass `#C08A3E` + brass-hot fill). Holding
 * the values in one module makes future palette tweaks (theme v1.1+)
 * a single-file change.
 *
 * Sprint 18 D0 — palette migrated to zenit-platform 2 / zenit-
 * foundation 2 mockup canonical values. ADR-0034 + REFERENCE_
 * PARITY_AUDIT.md §0.1.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
// — Palette (Zenit §7.1 / §7.2) ———————————————————————————————————
export const STROKE_IVORY = "#EFE6D2";
export const STROKE_BRASS = "#C08A3E";
export const STROKE_BRASS_HOT = "#E8B35C";
/** LED diode body fill — semi-transparent brass-hot per Zenit §9.2 */
export const FILL_LED = "rgba(232,179,92,0.3)";
// — Stroke widths (Zenit §9.1 — 1.3-1.6 zorunlu range) —————————————
export const STROKE_WIDTH_MAIN = 1.4;
export const STROKE_WIDTH_DETAIL = 1.3;
export const STROKE_WIDTH_HEAVY = 1.6;
// — ViewBox defaults (Zenit §9.1) —————————————————————————————————
export const VIEWBOX_DEFAULT = "0 0 40 26";
export const VIEWBOX_COMPACT = "0 0 36 24";
//# sourceMappingURL=constants.js.map